import React from 'react';
import { Col, FormGroup, Input, Row } from '../../../../components/Bootstrap';
import { MenuOption } from '../../types';
import { DeleteIcon } from '../DeleteIcon';
const classNames = require('classnames');

interface OptionsListEditorRowProps {
  disabled: boolean;
  option: MenuOption;
  index: any;
  isPOSItem: boolean;
  onDelete(item: MenuOption): void;
  onChangeName(originalOption: MenuOption, name: string): void;
  onChangePrice(originalOption: MenuOption, price: number): void;
}

export const OptionsListEditorRow: React.FC<OptionsListEditorRowProps> = (props) => {
  const { disabled, option, index, isPOSItem, onDelete, onChangeName, onChangePrice } = props;
  const handleDelete = React.useCallback(() => {
    onDelete(option);
  }, [onDelete, option]);

  const handleNameChange: React.ChangeEventHandler<HTMLInputElement> = React.useCallback(
    (e) => {
      onChangeName(option, e.target.value);
    },
    [onChangeName, option]
  );

  const [price, setPrice] = React.useState<string>(`${option.price}`);
  React.useEffect(() => {
    setPrice(`${option.price}`);
  }, [option]);

  const handlePriceChange: React.ChangeEventHandler<HTMLInputElement> = React.useCallback(
    (e) => {
      const { value } = e.target;
      setPrice(value);
    },
    [setPrice]
  );

  const handleBlur: React.FocusEventHandler<HTMLInputElement> = React.useCallback(() => {
    onChangePrice(option, parseFloat(price));
  }, [price, onChangePrice, option]);

  return (
    <Row className='options-row mb-3'>
      <Col xs={5}>
        <Input
          disabled={!!option.id || !!option.option.id}
          onChange={handleNameChange}
          type='text'
          name='name'
          id='name'
          value={option.option.name}
          className='w-100'
        />
      </Col>
      <Col xs={4}>
        <FormGroup className='ms-3'>
          <Input
            onChange={handlePriceChange}
            value={disabled ? 'Base Price' : price}
            type='text'
            name='price'
            id='price'
            disabled={disabled || isPOSItem}
            onBlur={handleBlur}
          />
        </FormGroup>
      </Col>
      <Col xs={2}>
        {index !== 0 && (
          <div className='d-flex align-items-center ps-3 h-100'>
            <DeleteIcon onClick={handleDelete} className={classNames('img-fluid')} />
          </div>
        )}
      </Col>
    </Row>
  );
};
